import find from 'lodash/find';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveFilterByType } from '@common/Filters/actions/filtersActions';
import { priceRangeMinMax } from '@common/Filters/constants/filterTypes';
import { RangeSelect } from '@common/Form';
import { useTranslation } from '@common/Hooks/useTranslation';

export function FiltersPrice() {
    const translate = useTranslation();
    const dispatch = useDispatch();
    const { activeFilters, availableFilters } = useSelector(({ filters }) => filters);
    const { [priceRangeMinMax]: priceRangeMinMaxConfig } = availableFilters;
    const { max, min } = priceRangeMinMaxConfig;
    const rangeFromState = find(activeFilters, ({ filterType }) => filterType === priceRangeMinMax);
    const currentRange = useMemo(() => {
        if (rangeFromState) {
            return rangeFromState.value.split('-').map(item => parseInt(item, 10));
        }

        return [min, max];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rangeFromState]);

    const handleChange = (value) => {
        dispatch(setActiveFilterByType({
            name: translate('listing.filter.pricerange-minmax.label'),
            value: value.join('-'),
            filterType: priceRangeMinMax
        }));
    };

    return (
        <RangeSelect
            className="pl-20 pr-20"
            max={max}
            min={min}
            value={currentRange}
            onChange={handleChange}
        />
    );
}
